import { mutation } from '@/helpers/westeros';
import actionsFactory from './actions';

export default {
  actions: actionsFactory(mutation),
};
